import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { useLang } from "./ctx";
import { CONTACT } from "../../content";
import { MaskLines, Reveal, Label } from "./Motion";

const Item = ({ icon: Icon, label, value, href, testid, external }) => (
  <a href={href} data-testid={testid} {...(external ? { target: "_blank", rel: "noreferrer" } : {})} className="group flex items-start gap-4 border-t border-white/15 py-6 sm:gap-6 sm:py-8 transition-colors duration-500 hover:border-[#C9A96E]">
    <Icon size={20} strokeWidth={1.25} className="mt-1 shrink-0 text-[#C9A96E]" />
    <div className="min-w-0 flex-1">
      <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-stone-400">{label}</div>
      <div className="mt-3 break-words font-display text-xl text-white sm:text-3xl">{value}</div>
    </div>
    <ArrowUpRight size={22} strokeWidth={1.25} className="shrink-0 text-stone-400 transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#C9A96E]" />
  </a>
);

export const Contact = () => {
  const { t, lang } = useLang();
  const c = t.contact;
  const map = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT.address)}`;
  return (
    <section id="contact" className="relative overflow-hidden bg-[#14120F] pb-32 pt-20 text-white sm:py-28 lg:py-40" data-testid="contact-section">
      <img src="/assets/icon-light.png" alt="" className="pointer-events-none absolute -right-20 bottom-0 w-[60%] max-w-[760px] opacity-[0.04]" />
      <div className="relative mx-auto grid max-w-[1440px] gap-10 px-6 sm:gap-16 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <Label light>{c.label}</Label>
          <h2 key={lang} className="mt-8 font-display text-5xl font-light leading-[1] tracking-tight sm:text-6xl lg:text-7xl">
            <MaskLines lines={[c.title[0]]} />
            <MaskLines lines={[c.title[1]]} delay={0.12} lineClass="italic text-[#C9A96E]" />
          </h2>
          <Reveal><p className="mt-8 max-w-md text-base leading-relaxed text-stone-300">{c.sub}</p></Reveal>
        </div>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <Item icon={MapPin} label={c.address} value={CONTACT.address} href={map} testid="contact-address-text" external />
          <Item icon={Phone} label={c.phone} value={CONTACT.phone} href={CONTACT.phoneHref} testid="contact-phone-link" />
          <div className="border-b border-white/15">
            <Item icon={Mail} label={c.email} value={CONTACT.email} href={`mailto:${CONTACT.email}`} testid="contact-email-link" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
